import CustomPrefixTextFieldExample from "./examples/CustomPrefix.TextField.Example";
import InlineTextField from "./examples/Inline.TextField.Example";
import MessageTextFieldExample from "./examples/Message.TextField.Example";
import MultiLineTextFieldExample from "./examples/MultiLine.TextField.Example";
import TextFieldExample from "./examples/TextField.Example";
import TextFieldFormItemExample from "./examples/TextField.FormItem.Example";

export default [
    {
        title: "Basic text field",
        component: TextFieldExample,
        code: require("!raw-loader!./examples/TextField.Example.tsx")
    },
    {
        title: "Inline text field",
        component: InlineTextField,
        code: require("!raw-loader!./examples/Inline.TextField.Example.tsx")
    },
    {
        title: "Multi-line text field",
        component: MultiLineTextFieldExample,
        code: require("!raw-loader!./examples/MultiLine.TextField.Example.tsx")
    },
    {
        title: "Text field with error",
        component: MessageTextFieldExample,
        code: require("!raw-loader!./examples/Message.TextField.Example.tsx")
    },
    {
        title: "Text field with label",
        component: CustomPrefixTextFieldExample,
        code: require("!raw-loader!./examples/CustomPrefix.TextField.Example.tsx")
    },
    {
        title: "Text field as Form Item",
        component: TextFieldFormItemExample,
        code: require("!raw-loader!./examples/TextField.FormItem.Example.tsx")
    }
];
